import { ref } from 'vue'
import StandaloneHotelOrderService from '@/services/StandaloneHotelOrderService'

// Whether the home page search shows the Hotels tab. Hidden until the switch is read, and when it can't be.
// main.js asks for it before the app mounts on the home page, and the home hero again when reached from
// another page (prefetchHotelSearchEnabled), so the Classic Search tabs usually have it on their first render.
export function useHotelSearchEnabled() {
  const known = StandaloneHotelOrderService.searchEnabledNow()
  const enabled = ref(known ?? false)
  if (known === null) {
    StandaloneHotelOrderService.searchEnabled().then((on) => (enabled.value = on))
  }
  return { enabled }
}

export function prefetchHotelSearchEnabled() {
  void StandaloneHotelOrderService.searchEnabled()
}
